(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-sse'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-sse'.");
    }
    globalThis['ktor-ktor-sse'] = factory(typeof globalThis['ktor-ktor-sse'] === 'undefined' ? {} : globalThis['ktor-ktor-sse'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var toString = kotlin_kotlin.$_$.hp;
  var hashCode = kotlin_kotlin.$_$.bg;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ServerSentEvent, 'ServerSentEvent', ServerSentEvent);
  initMetadataForClass(TypedServerSentEvent, 'TypedServerSentEvent', TypedServerSentEvent);
  //endregion
  function get_END_OF_LINE_VARIANTS() {
    _init_properties_ServerSentEvent_kt__rkyey5();
    return END_OF_LINE_VARIANTS;
  }
  var END_OF_LINE_VARIANTS;
  function ServerSentEvent(data, event, id, retry, comments) {
    data = data === VOID ? null : data;
    event = event === VOID ? null : event;
    id = id === VOID ? null : id;
    retry = retry === VOID ? null : retry;
    comments = comments === VOID ? null : comments;
    this.gte_1 = data;
    this.hte_1 = event;
    this.ite_1 = id;
    this.jte_1 = retry;
    this.kte_1 = comments;
  }
  protoOf(ServerSentEvent).toString = function () {
    return eventToString(this.gte_1, this.hte_1, this.ite_1, this.jte_1, this.kte_1);
  };
  protoOf(ServerSentEvent).hashCode = function () {
    var result = this.gte_1 == null ? 0 : getStringHashCode(this.gte_1);
    result = imul(result, 31) + (this.hte_1 == null ? 0 : getStringHashCode(this.hte_1)) | 0;
    result = imul(result, 31) + (this.ite_1 == null ? 0 : getStringHashCode(this.ite_1)) | 0;
    result = imul(result, 31) + (this.jte_1 == null ? 0 : this.jte_1.hashCode()) | 0;
    result = imul(result, 31) + (this.kte_1 == null ? 0 : getStringHashCode(this.kte_1)) | 0;
    return result;
  };
  protoOf(ServerSentEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ServerSentEvent))
      return false;
    if (!(this.gte_1 == other.gte_1))
      return false;
    if (!(this.hte_1 == other.hte_1))
      return false;
    if (!(this.ite_1 == other.ite_1))
      return false;
    if (!equals(this.jte_1, other.jte_1))
      return false;
    if (!(this.kte_1 == other.kte_1))
      return false;
    return true;
  };
  function TypedServerSentEvent(data, event, id, retry, comments) {
    data = data === VOID ? null : data;
    event = event === VOID ? null : event;
    id = id === VOID ? null : id;
    retry = retry === VOID ? null : retry;
    comments = comments === VOID ? null : comments;
    this.lte_1 = data;
    this.mte_1 = event;
    this.nte_1 = id;
    this.ote_1 = retry;
    this.pte_1 = comments;
  }
  protoOf(TypedServerSentEvent).toString = function () {
    return 'TypedServerSentEvent(data=' + toString(this.lte_1) + ', event=' + this.mte_1 + ', id=' + this.nte_1 + ', retry=' + toString(this.ote_1) + ', comments=' + this.pte_1 + ')';
  };
  protoOf(TypedServerSentEvent).hashCode = function () {
    var result = this.lte_1 == null ? 0 : hashCode(this.lte_1);
    result = imul(result, 31) + (this.mte_1 == null ? 0 : getStringHashCode(this.mte_1)) | 0;
    result = imul(result, 31) + (this.nte_1 == null ? 0 : getStringHashCode(this.nte_1)) | 0;
    result = imul(result, 31) + (this.ote_1 == null ? 0 : this.ote_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pte_1 == null ? 0 : getStringHashCode(this.pte_1)) | 0;
    return result;
  };
  protoOf(TypedServerSentEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypedServerSentEvent))
      return false;
    if (!equals(this.lte_1, other.lte_1))
      return false;
    if (!(this.mte_1 == other.mte_1))
      return false;
    if (!(this.nte_1 == other.nte_1))
      return false;
    if (!equals(this.ote_1, other.ote_1))
      return false;
    if (!(this.pte_1 == other.pte_1))
      return false;
    return true;
  };
  function eventToString(data, event, id, retry, comments) {
    _init_properties_ServerSentEvent_kt__rkyey5();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    appendField(this_0, 'event', event);
    appendField(this_0, 'data', data);
    appendField(this_0, 'id', id);
    appendField(this_0, 'retry', retry);
    appendField(this_0, '', comments);
    return this_0.toString();
  }
  function appendField(_this__u8e3s4, name, value) {
    _init_properties_ServerSentEvent_kt__rkyey5();
    if (!(value == null)) {
      var tmp0 = toString_0(value);
      // Inline function 'kotlin.text.split' call
      var values = get_END_OF_LINE_VARIANTS().ge(tmp0, 0);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        _this__u8e3s4.q(name + ': ' + element + '\r\n');
      }
    }
  }
  var properties_initialized_ServerSentEvent_kt_x8r4bz;
  function _init_properties_ServerSentEvent_kt__rkyey5() {
    if (!properties_initialized_ServerSentEvent_kt_x8r4bz) {
      properties_initialized_ServerSentEvent_kt_x8r4bz = true;
      END_OF_LINE_VARIANTS = Regex_init_$Create$('\r\n|\r|\n');
    }
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ServerSentEvent;
  _.$_$.b = TypedServerSentEvent;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-sse.js.map
